import * as React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import MessageIcon from '@mui/icons-material/Message';
import ListIcon from '@mui/icons-material/List';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/actions/auth';
import API_URL from '../../services/index';

function DesktopAccountMenu() {
  const dispatch = useDispatch();
  const { user: { user: accountData } } = useSelector((state) => state.auth);
  let { profile_image: profileImage } = accountData;
  const { full_name: fullName } = accountData;
  profileImage = profileImage === ''
    ? null : `${API_URL}${profileImage}`;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title={fullName}>
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }} src={profileImage} alt={fullName} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <Avatar
            src={profileImage}
            sx={{ width: 56, height: 56 }}
            alt={fullName}
          />
          <Link to="dashboard">
            <span className="text-main">My Account</span>
          </Link>
        </MenuItem>
        <MenuItem>
          <MessageIcon className="mr-3 text-main" />
          <Link to="dashboard">
            <span className="text-main">Messages</span>
          </Link>
        </MenuItem>
        <MenuItem>
          <ListIcon className="mr-3 text-main" />
          <Link to="dashboard">
            <span className="text-main">My Servces</span>
          </Link>
        </MenuItem>
        <MenuItem>
          <FavoriteBorderIcon className="mr-3 text-main" />
          <Link to="dashboard">
            <span className="text-main">Favorite</span>
          </Link>
        </MenuItem>
        <MenuItem>
          <ProductionQuantityLimitsIcon className="mr-3 text-main" />
          <Link to="dashboard">
            <span className="text-main">Requests</span>
          </Link>
        </MenuItem>
        <Divider />
        <MenuItem>
          <ListItemIcon>
            <Logout fontSize="small" className="text-main" />
          </ListItemIcon>
          <span id="userLogout" className="text-main" onClick={handleLogout} aria-hidden="true">Logout</span>
        </MenuItem>
      </Menu>
    </>
  );
}

export default DesktopAccountMenu;
